import { useState } from 'react';
import {
  AutocompleteController,
  AutocompleteProps,
} from './store/AutocompleteController';
import { shallowEqual, usePrevious } from '@apia/util';
import { AutocompleteContext } from './Context';
import { getVariant, InputProps } from '@apia/theme';
import { SearchBox } from './SearchBox';
import { KeyHandler } from './Keyhandler';

export type AutocompleteCmpProps = {
  handler?: AutocompleteController;
  getHandler?: (handler: AutocompleteController) => unknown;
  properties?: AutocompleteProps;
  inputProps?: InputProps;
  boxProps?: React.HTMLAttributes<HTMLDivElement>;
};

export const Autocomplete = (props: AutocompleteCmpProps) => {
  const [handler] = useState<AutocompleteController>(() => {
    const newHandler =
      props.handler ?? new AutocompleteController(props.properties ?? {});
    props.getHandler?.(newHandler);
    return newHandler;
  });

  const prevProps = usePrevious(props.properties);
  if (!shallowEqual(prevProps.current, props.properties) && handler?.state) {
    Object.assign(handler!.state, props.properties);
    if (
      prevProps.current?.value !== props.properties?.value &&
      props.properties?.value !== undefined
    ) {
      const defaultForce = prevProps.current?.value === undefined;
      handler.setValue(props.properties.value, {
        fireOnChange: false,
        force:
          props.properties.onForce?.(
            props.properties.value,
            handler,
            prevProps.current?.value,
          ) ?? defaultForce,
      });
    }
  }

  if (!handler) {
    return null;
  }

  return (
    <AutocompleteContext.Provider value={handler}>
      <KeyHandler
        {...props.boxProps}
        className={`autocomplete ${props.properties?.className || ''}`}
        data-autocomplete-box={handler.state.id}
        {...getVariant('layout.common.components.autocomplete')}
      >
        <SearchBox {...props.inputProps} />
      </KeyHandler>
    </AutocompleteContext.Provider>
  );
};

export * from './store/AutocompleteController';
